var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenCurlyBracket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.141,
    height: 107.352,
    viewBox: "0 0 33.141 107.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_154",
    x: 0,
    y: 0,
    width: 33.141,
    height: 107.352,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154-2",
    "data-name": "Path 154",
    d: "M34.563,20.016q-9.68-2.734-14.574-9T15.094-5.523V-16.406Q15.094-29.7,3.5-29.7v-7.93q11.594,0,11.594-13.234V-62.234q.109-10.008,4.895-16.16t14.574-8.941l2.078,6.289q-11.43,3.664-11.43,19.086v11.047q0,12.414-9.133,17.281,9.133,4.922,9.133,17.445V-4.922q.164,15.039,11.43,18.648Z",
    transform: "translate(-3.5 87.336)",
    fill: "#006151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154-3",
    "data-name": "Path 154",
    d: "M34.563,20.016q-9.68-2.734-14.574-9T15.094-5.523V-16.406Q15.094-29.7,3.5-29.7v-7.93q11.594,0,11.594-13.234V-62.234q.109-10.008,4.895-16.16t14.574-8.941l2.078,6.289q-11.43,3.664-11.43,19.086v11.047q0,12.414-9.133,17.281,9.133,4.922,9.133,17.445V-4.922q.164,15.039,11.43,18.648Z",
    transform: "translate(-3.5 87.34)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCurlyBracket);
export default __webpack_public_path__ + "static/media/open-curly-bracket.0067fe898b13e45eb4e7f753d2d8e491.svg";
export { ForwardRef as ReactComponent };